/* English. Every key here must exist in ar.ts and hi.ts with the same {placeholders} (test/unit/i18n.test.ts checks it).
   Company facts that aren't decided yet are in [brackets]; README lists them. */
export const en = {
  /* company facts (placeholders until decided) */
  'company.privacyEmail': 'hello@pathsabroad.com',
  'company.supportEmail': 'hello@pathsabroad.com',

  /* app chrome */
  'app.skip': 'Skip to main content',
  'app.home': 'PathsAbroad home',
  'lang.label': 'Language',
  'nav.sections': 'Account sections',
  'nav.overview': 'Overview',
  'nav.profile': 'Profile',
  'nav.inbox': 'Application inbox',
  'nav.plans': 'Plans',
  'nav.extension': 'Chrome extension',
  'nav.security': 'Sign-in and security',
  'nav.data': 'Your data',
  'nav.account': 'Account',
  'nav.planner': 'Open the planner',
  'nav.signin': 'Sign in',
  'nav.signout': 'Sign out',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.note': 'No ads, no tracking. Only the cookies that keep you signed in.',

  /* shared words */
  'common.loading': 'Loading…',
  'common.retry': 'Try again',
  'common.continue': 'Continue',
  'common.cancel': 'Cancel',
  'common.save': 'Save changes',
  'common.saving': 'Saving…',
  'common.copied': 'Copied',
  'common.copyFailed': 'Couldn’t copy. Select the text and copy it yourself.',
  'common.show': 'Show',
  'common.hide': 'Hide',
  'common.showPassword': 'Show password',
  'common.hidePassword': 'Hide password',
  'common.optional': 'optional',
  'common.choose': 'Choose…',
  'common.remove': 'Remove',
  'common.removeNamed': 'Remove {name}',
  'common.email': 'Email',
  'common.password': 'Password',
  'common.on': 'On',
  'common.off': 'Off',
  'common.opensNew': '(opens in a new tab)',
  'common.home': 'Go to the home page',
  'session.checking': 'Checking your session…',
  'session.error': 'We couldn’t reach PathsAbroad to check your session.',

  /* errors */
  'err.bad_credentials': 'That email and password don’t match. Try again, or reset your password.',
  'err.email_not_confirmed': 'Confirm your email first by typing the 6-digit code we sent you.',
  'err.bad_code': 'That code didn’t work. Check it and try again, or get a new one.',
  'err.already_paid': 'You already have this pass for this season.',
  'err.withdrawal_ack_required': 'Tick the box to say you understand that all sales are final, then try again.',
  'err.version_conflict': 'This changed somewhere else. Reload the page to see the latest version.',
  'err.invalid': 'Some details need checking. Look at the highlighted field.',
  'err.not_found': 'We couldn’t find that. It may have been removed.',
  'err.rate_limited': 'Too many tries. Wait a few minutes, then try again.',
  'err.forbidden': 'This isn’t available for your account.',
  'err.network': 'Can’t reach PathsAbroad. Check your connection and try again.',
  'err.server_error': 'Something went wrong on our side. Try again in a minute.',
  'err.signed_out': 'Your session has ended. Sign in again.',
  'err.mfa_required': 'Type your two-step sign-in code first.',
  'err.guardian_consent_required': 'A parent or guardian needs to approve your account first.',
  'err.plan_required': 'This needs the Apply & Arrive pass.',

  /* field checks */
  'v.email': 'Enter an email address like name@example.com.',
  'v.password': 'Use at least 10 characters.',
  'v.passwordMatch': 'The passwords don’t match.',
  'v.code': 'Enter the 6-digit code.',
  'v.required': 'Fill in this field.',
  'v.tick': 'Tick this box to continue.',
  'v.choose': 'Choose an option.',

  /* password strength */
  'pw.hint': 'At least 10 characters. A short sentence is easy to remember and hard to guess.',
  'pw.strength': 'Strength: {level}',
  'pw.too_short': 'too short',
  'pw.weak': 'weak',
  'pw.fair': 'fair',
  'pw.strong': 'strong',

  /* welcome */
  'home.title': 'Study abroad, one clear step at a time.',
  'home.lead': 'PathsAbroad helps you find universities that fit you, apply on your own terms, get ready for your visa with official information and settle in.',
  'home.start': 'Find your universities',
  'home.signin': 'Sign in',
  'home.planner': 'Open the planner',
  'home.pathTitle': 'Your path',
  'home.step0.text': 'Tell us about yourself once. Your details stay yours: download or delete them any time.',
  'home.step1.text': 'Choose any university, including ones we didn’t suggest. You submit every application and pay every fee yourself.',
  'home.step2.text': 'Admissions emails arrive in one inbox, sorted, with the next steps pulled out for you.',
  'home.step3.text': 'Visa checklists from official sources, plus housing and your first weeks. General information, not immigration or legal advice.',

  /* the four stops */
  'phase.0': 'Profile',
  'phase.1': 'Apply',
  'phase.2': 'Admit',
  'phase.3': 'Arrive',
  'phase.here': 'you are here',
  'phase.done': 'done',
  'phase.summary': 'Step {n} of 4: {name}',

  /* start: age question and sign-up */
  'auth.step': 'Step {n} of {total}',
  'auth.saveList': 'Save your list',
  'auth.beginWith': 'Starting with {school}',
  'auth.welcomeBack': 'Welcome back',
  'start.dob.title': 'When were you born?',
  'start.dob.day': 'Day',
  'start.dob.month': 'Month',
  'start.dob.year': 'Year',
  'dob.missing': 'Choose the day, month and year.',
  'dob.no_such_day': 'That date doesn’t exist. Check the day and month.',
  'dob.check': 'Check your date of birth.',
  'start.blocked.title': 'Sorry, we can’t create a PathsAbroad account for you.',
  'start.form.title': 'Create your account',
  'start.form.emailHint': 'We’ll send a code to check it’s yours.',
  'start.form.lang': 'Language',
  'start.form.langHint': 'For the app and the emails we send you.',
  'start.form.minor': 'A parent or guardian will need to approve your account before you can save your details.',
  'start.form.agree': 'By creating an account, you agree to the {terms} and confirm you have read the {privacy}.',
  'start.form.termsLink': 'Terms',
  'start.form.privacyLink': 'Privacy notice',
  'start.form.submit': 'Create account',
  'start.form.changeDob': 'Change date of birth',
  'start.haveAccount': 'Already have an account?',

  /* verify email */
  'verify.title': 'Check your email',
  'verify.sent': 'We sent a 6-digit code to {email}. It can take a minute to arrive.',
  'verify.noEmail': 'Type the email you signed up with and the 6-digit code we sent you.',
  'verify.code': '6-digit code',
  'verify.submit': 'Verify email',
  'verify.resend': 'Send a new code',
  'verify.resendIn': 'Send a new code in {time}',
  'verify.resent': 'We sent a new code to {email}.',
  'verify.rateLimited': 'You’ve asked for several codes. Wait a few minutes before asking again.',
  'verify.noResend': 'To get a new code, start again. We don’t keep your sign-up details in this browser.',
  'verify.startAgain': 'Start again',

  /* link callback */
  'callback.title': 'Signing you in',
  'callback.working': 'One moment…',
  'callback.failed': 'This sign-in link didn’t work. It may have expired or been used already.',
  'callback.signin': 'Go to sign in',

  /* sign in */
  'signin.title': 'Sign in',
  'signin.forgot': 'Forgot your password?',
  'signin.new': 'Don’t have an account?',
  'signin.create': 'Create an account',
  'signin.enterCode': 'Enter your code',
  'code.title': 'Enter your sign-in code',
  'code.lead': 'Open your authenticator app and type the 6-digit code it shows for PathsAbroad.',
  'code.label': '6-digit code',
  'code.switch': 'Use a different account',
  'code.help': 'Lost your phone? Email {email} from the address you signed up with.',

  /* reset password */
  'reset.title': 'Reset your password',
  'reset.lead': 'Type the email you use for PathsAbroad. We’ll send you a 6-digit code.',
  'reset.send': 'Send code',
  'reset.sent': 'If there’s an account for {email}, we’ve sent a 6-digit code to it.',
  'reset.newPassword': 'New password',
  'reset.submit': 'Set new password',
  'reset.otherEmail': 'Use a different email',
  'reset.back': 'Back to sign in',

  /* guardian needed (the student) */
  'gn.title': 'A parent or guardian needs to say yes',
  'gn.lead': 'Because you’re under 18, a parent or guardian needs to agree before PathsAbroad saves anything about you, like your profile, school list or documents.',
  'gn.whatTitle': 'What they agree to',
  'gn.what1': 'That PathsAbroad can save your profile and use it to help with your applications.',
  'gn.what2': 'That you can use the planner, the application inbox and the Chrome extension.',
  'gn.what3': 'We won’t ask for sensitive details like religion or family income while you’re under 18.',
  'gn.howTitle': 'How it works',
  'gn.how1': 'We email a link to the address you type below.',
  'gn.how2': 'The page explains what we store and why. They can agree or say no.',
  'gn.how3': 'If they agree, your account opens fully. They can change their mind later, and that deletes your account.',
  'gn.whyTitle': 'Why we ask',
  'gn.why': 'Laws in many countries protect people under 18 online. Asking a parent or guardian keeps you both in the loop.',
  'gn.formTitle': 'Send the request',
  'gn.email': 'Parent’s or guardian’s email',
  'gn.lang': 'Language for their email',
  'gn.submit': 'Send request',
  'gn.sameEmail': 'Use your parent’s or guardian’s own email, not yours.',
  'gn.sent': 'Request sent to {email}.',
  'gn.rateLimited': 'You can send up to 3 requests a day. Try again tomorrow.',
  'gn.pending.title': 'Waiting for an answer',
  'gn.pending.text': 'We emailed your parent or guardian. The link works for 14 days, and this page updates by itself.',
  'gn.check': 'Check now',
  'gn.resend': 'Send it again',
  'gn.granted.title': 'Your parent or guardian said yes',
  'gn.granted.text': 'Your account is ready. You can now save your profile and use everything in PathsAbroad.',
  'gn.granted.go': 'Go to your account',
  'gn.denied.title': 'Your parent or guardian said no',
  'gn.denied.text': 'You can talk with them and send a new request, or ask another parent or guardian.',
  'gn.expired.title': 'The link expired',
  'gn.expired.text': 'Nobody answered within 14 days. You can send a new request below.',
  'gn.revoked.title': 'Consent was withdrawn',
  'gn.revoked.text': 'Your parent or guardian withdrew their consent.',
  'gn.limited': 'Until then, you can read our privacy notice and terms, or sign out.',

  /* guardian consent page (the parent or guardian) */
  'gc.title': 'A student asked for your approval',
  'gc.lead': '{student} wants to use PathsAbroad. Because they’re under 18, we need a parent or legal guardian to agree first.',
  'gc.aboutTitle': 'What PathsAbroad is',
  'gc.about': 'PathsAbroad helps students choose universities abroad, prepare their applications, get ready for their visa with information from official sources and settle in. Students submit every application and pay any school fees themselves. PathsAbroad is not a school, an agent or an immigration adviser.',
  'gc.storeTitle': 'What we store about the student',
  'gc.store1': 'Their profile for applications: names, date of birth, citizenship, contact details, schools and grades, family details and study plans. Date of birth, citizenship and any passport number are encrypted.',
  'gc.store2': 'Sensitive details such as ethnicity, religion or family income: never while they’re under 18. After they turn 18, they can choose to add each one separately, only for scholarship matching.',
  'gc.store3': 'Inbox summaries: if they use their PathsAbroad application inbox, we keep short summaries of admissions emails. Full messages are kept while their pass lasts, and at least 30 days, then deleted.',
  'gc.store4': 'Payments: if a paid plan is bought, Stripe handles the card details. We never see the card number.',
  'gc.store5': 'No ads, no tracking, and we never sell data.',
  'gc.rightsTitle': 'Your rights',
  'gc.rights1': 'See or download the student’s data, or ask us to correct or delete it, by emailing {email}.',
  'gc.rights2': 'Withdraw your consent at any time. After you agree, we’ll email you a separate link for this. Withdrawing deletes the student’s account and data.',
  'gc.rights3': 'Complain to your data protection authority if you think we got something wrong.',
  'gc.formTitle': 'Your decision',
  'gc.name': 'Your full name',
  'gc.relationship': 'Your relationship to the student',
  'gc.confirm': 'I am this student’s parent or legal guardian and I am 18 or older',
  'gc.agree': 'Agree',
  'gc.decline': 'Decline',
  'gc.ignore': 'Not the right person? You can ignore this request. It expires on {date}.',
  'gc.missing': 'This page needs the link from the email we sent.',
  'gc.invalid.title': 'This link isn’t valid',
  'gc.invalid.text': 'It may have been replaced by a newer request. Ask the student to send a new one.',
  'gc.granted.title': 'Thank you. You agreed.',
  'gc.granted.text': '{student} can now use PathsAbroad. We’ve emailed you a separate link you can use to withdraw consent at any time.',
  'gc.denied.title': 'You declined',
  'gc.denied.text': 'PathsAbroad won’t store anything more about the student. Their account stays limited unless a parent or guardian agrees.',
  'gc.already.granted': 'You already agreed to this request. To withdraw consent, use the link in the email we sent after you agreed.',
  'gc.already.denied': 'You already declined this request.',
  'gc.already.expired': 'This request has expired. The student can send a new one.',
  'gc.already.revoked': 'Consent for this account was withdrawn.',

  /* guardian withdraw */
  'gw.title': 'Withdraw your consent',
  'gw.lead': 'If you withdraw consent, we delete the student’s PathsAbroad account and all of their data: profile, school list, essays, application inbox, messages and tasks. This can’t be undone.',
  'gw.kept': 'Stripe keeps records of any payments for as long as tax law requires. We keep a record that the account was deleted, with no personal details.',
  'gw.confirm': 'I understand that this deletes the student’s account and data',
  'gw.submit': 'Withdraw consent and delete the account',
  'gw.done.title': 'Consent withdrawn',
  'gw.done.text': 'We’ve deleted the student’s account and data, and emailed you both to confirm.',
  'gw.invalid': 'This link isn’t valid or has already been used.',

  /* relationships, education */
  'rel.mother': 'Mother',
  'rel.father': 'Father',
  'rel.guardian': 'Legal guardian',
  'rel.other': 'Other',
  'edu.none': 'No formal schooling',
  'edu.primary': 'Primary school',
  'edu.secondary': 'Secondary school',
  'edu.some_university': 'Some university',
  'edu.bachelor': 'Bachelor’s degree',
  'edu.master': 'Master’s degree',
  'edu.doctorate': 'Doctorate',
  'edu.unknown': 'Don’t know',

  /* account overview */
  'acct.greeting': 'Hi, {name}',
  'acct.greetingNoName': 'Welcome back',
  'acct.hero.title': 'Pick up where you left off',
  'acct.hero.text': 'Your school list, visa checklist and funding tracker are in the planner.',
  'acct.status': 'Status',
  'acct.consent': 'Parent or guardian consent',
  'acct.consentGranted': 'Approved',
  'acct.freePlan': 'Free plan',
  'acct.seePlans': 'See plans',
  'acct.pass': '{plan} pass',
  'acct.validUntil': 'Valid until {date}',
  'acct.mfa': 'Two-step sign-in',
  'acct.mfaNudge': 'We recommend turning on two-step sign-in, so a stolen password isn’t enough to get into your account.',
  'acct.inbox': 'Application inbox',
  'acct.inboxNone': 'Get your address',
  'acct.withApply': 'Included with Apply & Arrive',
  'acct.extension': 'Chrome extension',
  'acct.extensionOn': 'Connected',
  'acct.extensionAdd': 'Add to Chrome',
  'acct.extensionSetUp': 'Set up',
  'acct.you': 'Your account',
  'acct.groupApply': 'Applying',
  'acct.groupYou': 'You and your plan',
  'acct.groupSafety': 'Privacy and security',
  'acct.groupPlanner': 'In the planner',
  'acct.profileSub': 'Your details, filled into your applications',
  'acct.familySub': 'A progress page for parents, and parents paying',
  'acct.dataSub': 'Download or delete everything',
  'acct.mfaShort': 'Two-step',
  'acct.tools': 'Tools and settings',
  'acct.toolsSub': 'Study plan, documents, dates, language practice and the light or dark look',
  'portal.label': 'Main',
  'portal.home': 'Home',
  'portal.explore': 'Explore',
  'portal.apply': 'Apply',
  'portal.account': 'Account',
  'acct.apps': 'Applications',
  'acct.appsEmpty': 'Your applications show up here once you add schools in the planner.',
  'acct.submitted': 'Submitted {date}',
  'acct.tasks': 'To do',
  'acct.tasksEmpty': 'Nothing to do right now.',
  'acct.due': 'Due {date}',
  'acct.manage': 'Your account',
  'acct.loadError': 'Couldn’t load this part. {retry}',
  'task.ai': 'AI',
  'task.aiFull': 'Suggested by AI',
  'task.email': 'From your inbox',
  'task.error': 'Couldn’t update this task. Try again.',
  'app.planned': 'Planned',
  'app.in_progress': 'In progress',
  'app.submitted': 'Submitted',
  'app.decision_admitted': 'Admitted',
  'app.decision_denied': 'Not admitted',
  'app.decision_waitlisted': 'Waitlisted',
  'app.decision_deferred': 'Deferred',
  'app.accepted': 'Offer accepted',
  'app.declined': 'Offer declined',
  'app.withdrawn': 'Withdrawn',

  /* profile */
  'profile.title': 'Profile',
  'profile.lead': 'Fill this in once. The extension uses it to fill in application portals, and you check everything before you submit.',
  'profile.sec.name': 'Your name',
  'profile.nameNote': 'Write your names exactly as they appear in your passport.',
  'f.given_name': 'Given name',
  'f.middle_name': 'Middle name',
  'f.family_name': 'Family name',
  'f.preferred_name': 'Preferred name',
  'profile.sec.about': 'About you',
  'f.dob': 'Date of birth',
  'f.gender': 'Gender',
  'gender.female': 'Female',
  'gender.male': 'Male',
  'gender.another': 'Another gender',
  'gender.none': 'Prefer not to say',
  'profile.sec.citizenship': 'Citizenship and where you live',
  'f.citizenship1': 'Citizenship',
  'f.citizenship2': 'Second citizenship',
  'f.birth_country': 'Country of birth',
  'f.home_country': 'Country you live in',
  'f.home_countryHint': 'Prices and visa checklists use this.',
  'f.first_language': 'First language',
  'profile.sec.contact': 'Contact',
  'f.phone': 'Phone',
  'f.phoneHint': 'Include your country code, like ⁦+971⁩.',
  'f.line1': 'Address line 1',
  'f.line2': 'Address line 2',
  'f.city': 'City',
  'f.region': 'State, province or region',
  'f.postal_code': 'Postal code',
  'f.country': 'Country',
  'profile.sec.study': 'What you want to study',
  'f.level': 'Level',
  'level.foundation': 'Foundation year',
  'level.diploma': 'Diploma or certificate',
  'level.bachelor': 'Bachelor’s degree',
  'level.master': 'Master’s degree',
  'level.phd': 'PhD',
  'f.field': 'Subject or major',
  'f.start_term': 'When you want to start',
  'term.label': '{month} {year}',
  'f.budget_usd': 'Yearly budget in US dollars',
  'f.budgetHint': 'Tuition and living costs together.',
  'profile.sec.english': 'English',
  'f.english_first': 'English is my first language',
  'f.english_type': 'English test',
  'test.none': 'Not taken yet',
  'test.other': 'Another test',
  'f.english_score': 'Score',
  'f.english_date': 'Test date',
  'profile.sec.passport': 'Passport',
  'f.passport_number': 'Passport number',
  'f.passportHint': 'Optional. Stored encrypted. The extension never fills it in.',
  'profile.sec.family': 'Family',
  'profile.familyLead': 'Application portals often ask about your parents or guardians.',
  'profile.familyItem': 'Parent or guardian {n}',
  'f.member_name': 'Name',
  'f.relation': 'Relationship',
  'f.education': 'Highest education',
  'f.occupation': 'Occupation',
  'profile.familyAdd': 'Add a parent or guardian',
  'profile.sec.schools': 'Schools',
  'profile.schoolsLead': 'Your secondary school and any university you attended.',
  'profile.schoolItem': 'School {n}',
  'f.school_name': 'School name',
  'f.start_date': 'Started',
  'f.end_date': 'Finished, or expected to finish',
  'f.test_type': 'Final exam or qualification',
  'f.test_typeHint': 'For example WAEC, CBSE, IGCSE or Tawjihi.',
  'f.test_score': 'Result',
  'profile.schoolAdd': 'Add a school',
  'profile.schoolNameRequired': 'Add the school name, or remove this school.',
  'profile.sec.sensitive': 'Scholarship matching',
  'profile.sensitiveLead': 'Optional. Some scholarships are only for students from certain backgrounds. You can choose to share each of these on its own.',
  'profile.sensitivePurpose': 'Used only to match you with scholarships that ask for it. Never sent to application portals, never used for marketing.',
  'profile.consent.race': 'Use my race or ethnicity for scholarship matching',
  'profile.consent.religion': 'Use my religion for scholarship matching',
  'profile.consent.family_income': 'Use my family income for scholarship matching',
  'f.race': 'Race or ethnicity',
  'f.religion': 'Religion',
  'f.family_income': 'Yearly family income in US dollars',
  'income.lt10k': 'Under $10,000',
  'income.10k_25k': '$10,000 to $25,000',
  'income.25k_50k': '$25,000 to $50,000',
  'income.50k_100k': '$50,000 to $100,000',
  'income.gt100k': 'Over $100,000',
  'profile.sensitiveCleared': 'This will be deleted when you save.',
  'profile.sensitiveMinor': 'Not available for students under 18.',
  'profile.sec.lang': 'Language',
  'f.lang': 'Language for emails',
  'profile.saved': 'Your profile is saved.',
  'profile.unsaved': 'You have unsaved changes.',

  /* inbox */
  'inbox.title': 'Application inbox',
  'inbox.lead': 'Your own email address for applications. Admissions emails sent to it are sorted here, with the dates and next steps pulled out. When a school sends a decision or asks for something, we email you.',
  'inbox.upsellTitle': 'Included with Apply & Arrive',
  'inbox.upsellText': 'With Apply & Arrive you get a PathsAbroad address to use on application portals, and every admissions email sorted in one place.',
  'inbox.seePlans': 'See plans',
  'inbox.address': 'Your inbox address',
  'inbox.copy': 'Copy address',
  'inbox.howTitle': 'Where to use it',
  'inbox.how1': 'Use it as your email address on application portals, like the Common App. The PathsAbroad extension fills it in for you.',
  'inbox.how2': 'Keep using your own email for everything else.',
  'inbox.how3': 'Full messages are kept while your pass lasts, and for at least 30 days. After that we keep a short summary, the dates, links and actions. We don’t keep attachments, so download documents from the school’s portal.',
  'inbox.messages': 'Messages',
  'inbox.empty': 'No admissions emails yet. They appear here as soon as one arrives.',
  'inbox.received': 'Received {date}',
  'inbox.dates': 'Dates',
  'inbox.links': 'Links',
  'inbox.actions': 'What to do',
  'inbox.viewFull': 'View full message',
  'inbox.hideFull': 'Hide full message',
  'inbox.fullGone': 'The full message has been deleted.',
  'inbox.fullExpires': 'This full message will be deleted on {date}.',
  'inbox.from': 'From',
  'inbox.subject': 'Subject',
  'cat.decision': 'Decision',
  'cat.interview_invite': 'Interview',
  'cat.missing_documents': 'Missing documents',
  'cat.financial_aid': 'Financial aid',
  'cat.portal_credentials': 'Portal login',
  'cat.submission_confirmation': 'Submitted',
  'cat.housing': 'Housing',
  'cat.visa_documents': 'Visa documents',
  'cat.other': 'Other',
  'decision.admitted': 'Admitted',
  'decision.denied': 'Not admitted',
  'decision.waitlisted': 'Waitlisted',
  'decision.deferred': 'Deferred',

  /* plans */
  'plans.title': 'Plans',
  'plans.lead': 'One payment per season. No subscription.',
  'plans.oneTime': 'One-time payment for this season. No automatic renewal.',
  'plans.validFor': 'Lasts {months} from the day you pay.',
  'plans.free': 'What you have now',
  'plans.freeTitle': 'Everything’s free',
  'plans.freeLead': 'Everything in PathsAbroad is free for you. Universities and student services pay us when a student enrols or signs up, never students.',
  'plans.get': 'Get {plan}',
  'plans.owned': 'You have this until {date}',
  'plans.ownedNoDate': 'You have this',
  'plans.bundlePartial': 'You already have {plan}. Apply & Arrive adds everything else.',
  'plans.redirecting': 'Taking you to secure checkout…',
  'plans.refund': 'All sales are final: no refunds. If you get no offer, your pass rolls over to next season.',
  'plans.startNowTitle': 'Before you buy',
  'plans.startNow': 'Start my pass as soon as I pay. I understand that all sales are final: once it starts, I can’t cancel it or get a refund.',
  'plans.startNowNote': 'If you don’t get an offer, your pass rolls over to the next season, free.',
  'plans.prices': 'Prices are in US dollars, set for where you live and the countries of your passports (price group {tier}).',
  'plans.noFees': 'PathsAbroad never collects school, test or visa fees. You pay those yourself, directly.',
  'plans.paidTitle': 'Thank you. Your payment went through.',
  'plans.paidWaiting': 'We’re adding your pass. This usually takes a few seconds.',
  'plans.paidReady': 'Your {plan} pass is ready.',
  'plans.paidEmail': 'A confirmation email is on its way.',
  'plans.paidSlow': 'This is taking longer than usual. Your payment is safe, and your pass will appear here soon. Reload this page in a minute.',
  'plans.canceled': 'Checkout canceled. You haven’t been charged.',
  'plans.receipts': 'Receipts and invoices',
  'plans.yourPasses': 'Your passes',
  'plans.choose': 'Choose a plan',
  'pass.active': 'Active',
  'pass.expired': 'Expired',
  'pass.refunded': 'Refunded',
  'pass.canceled': 'Canceled',
  'pass.paidOn': 'Paid {date}',
  'pass.validUntil': 'Valid until {date}',
  'pass.withdrawUntil': 'You can withdraw for a full refund until {date}.',
  'pass.withdraw': 'Withdraw from contract here',
  'pass.confirmTitle': 'Withdraw from this contract?',
  'pass.confirmRefund': 'You get a full refund to your original payment method.',
  'pass.confirmAccess': 'Your access to {plan} ends now.',
  'pass.confirmReceipt': 'We’ll email you a dated receipt.',
  'pass.confirm': 'Confirm withdrawal',
  'pass.keep': 'Keep my pass',
  'pass.withdrawn': 'Refunded on {date}. The refund is on its way to your original payment method.',
  'pass.withdrawOver': 'All sales are final: this pass can’t be withdrawn or refunded.',
  'ai.tag': 'AI',
  'ai.tagFull': 'Uses AI',

  /* extension */
  'ext.title': 'Chrome extension',
  'ext.lead': 'The PathsAbroad extension fills in your saved answers on application portals, so you only type them once.',
  'ext.upsell': 'The extension comes with Apply & Arrive.',
  'ext.howTitle': 'How it works',
  'ext.how1': 'Add it to Chrome from the Chrome Web Store. It takes one click.',
  'ext.how2': 'It connects by itself while you’re signed in to PathsAbroad in the same browser, and disconnects when you sign out.',
  'ext.how3': 'On your application page, press “Fill with PathsAbroad”. Check every field, then submit it yourself.',
  'ext.checking': 'Looking for the extension…',
  'ext.connecting': 'Connecting it to your account…',
  'ext.addTitle': 'Add PathsAbroad to Chrome',
  'ext.addText': 'One click in the Chrome Web Store, and it connects to your account by itself. There’s no code to type.',
  'ext.addButton': 'Add to Chrome',
  'ext.addSoon': 'The extension will be in the Chrome Web Store soon.',
  'ext.browsers': 'Works in Chrome, Edge, Brave and other browsers built on Chromium, on a computer.',
  'ext.onTitle': 'Connected in this browser',
  'ext.onText': 'Open your application on the Common App, UCAS, OUAC or uni-assist and press “Fill with PathsAbroad” at the bottom of the page.',
  'ext.onInstalled': 'PathsAbroad is installed and connected.',
  'ext.onBack': 'You can go back to your application now.',
  'ext.connected': 'Connected',
  'ext.errTitle': 'The extension didn’t connect',
  'ext.errText': 'Try again. If it still doesn’t connect, use a pairing code instead (below).',
  'ext.retry': 'Try again',
  'ext.phoneTitle': 'On your phone, use the PathsAbroad app',
  'ext.phoneText': 'The app opens your application inside it and fills it in for you. On a computer, add the extension to Chrome.',
  'ext.appStore': 'Download on the App Store',
  'ext.playStore': 'Get it on Google Play',
  'ext.appSoon': 'The app will be in the App Store and on Google Play soon.',
  'ext.otherTitle': 'Open PathsAbroad in Chrome or Edge',
  'ext.otherText': 'The extension works in Chrome, Edge and other browsers built on Chromium. Open PathsAbroad in one of them to add it.',
  'ext.inAppTitle': 'You’re in the PathsAbroad app',
  'ext.inAppText': 'Open your application from the planner. It opens inside the app, with a “Fill with PathsAbroad” button. You don’t need the extension here.',
  'ext.fillButton': 'Fill with PathsAbroad',
  'ext.codeTitle': 'Connect with a code',
  'ext.codeLead': 'Only if it doesn’t connect by itself',
  'ext.step2': 'Click “Get pairing code” below.',
  'ext.step3': 'Open the extension and type the code within 10 minutes.',
  'ext.getCode': 'Get pairing code',
  'ext.newCode': 'Get a new code',
  'ext.code': 'Your pairing code',
  'ext.copy': 'Copy code',
  'ext.expiresIn': 'Expires in {time}',
  'ext.expired': 'This code has expired. Get a new one.',
  'ext.oneUse': 'Each code works once.',
  'ext.minuteLeft': 'One minute left to use this code.',
  'ext.rulesTitle': 'What the extension does, and doesn’t do',
  'ext.rule1': 'It fills in your saved answers on supported application portals: the Common App, UCAS, OUAC and uni-assist.',
  'ext.ruleEmail': 'For your email, it fills in your PathsAbroad inbox address, so schools’ emails land in your application inbox.',
  'ext.rule2': 'You check every field, and you submit.',
  'ext.rule3': 'It never fills in essays or passwords.',
  'ext.rule4': 'It never clicks submit or pay.',
  'ext.rule5': 'It stays off visa and government websites.',
  'ext.notAffiliated': 'PathsAbroad is not affiliated with the Common App, UCAS, OUAC, uni-assist or any university.',

  /* security */
  'sec.title': 'Sign-in and security',
  'sec.mfaTitle': 'Two-step sign-in',
  'sec.mfaOffText': 'When it’s on, you type a code from an authenticator app each time you sign in, so a stolen password isn’t enough.',
  'sec.mfaOnText': 'You type a code from your authenticator app each time you sign in.',
  'sec.mfaTurnOn': 'Turn on two-step sign-in',
  'sec.mfaStep1': 'Install an authenticator app, such as Google Authenticator, Microsoft Authenticator or 1Password.',
  'sec.mfaStep2': 'Scan this QR code with the app.',
  'sec.mfaQr': 'QR code for your authenticator app',
  'sec.mfaOpenApp': 'On this phone? Open it in your authenticator app',
  'sec.mfaKey': 'Can’t scan it? Type this key into the app instead:',
  'sec.mfaCopyKey': 'Copy key',
  'sec.mfaStep3': 'Type the 6-digit code the app shows.',
  'sec.mfaVerify': 'Turn on',
  'sec.mfaEnabled': 'Two-step sign-in is on.',
  'sec.mfaTurnOff': 'Turn off',
  'sec.mfaConfirmOff': 'Turn off two-step sign-in? Your password alone would then be enough to sign in.',
  'sec.mfaKeepOn': 'Keep it on',
  'sec.mfaDisabled': 'Two-step sign-in is off.',
  'sec.pwTitle': 'Password',
  'sec.pwNew': 'New password',
  'sec.pwConfirm': 'Type it again',
  'sec.pwSubmit': 'Change password',
  'sec.pwDone': 'Your password has been changed.',
  'sec.signoutTitle': 'Sign out',
  'sec.signoutText': 'Sign out of PathsAbroad in this browser.',

  /* your data */
  'data.title': 'Your data',
  'data.lead': 'You can see what we hold about you, take a copy with you, or delete it.',
  'data.exportTitle': 'Download my data',
  'data.exportText': 'One JSON file with everything we hold about you: profile, applications, inbox summaries, tasks, consents and payments.',
  'data.exportDone': 'Your download has started.',
  'data.deleteTitle': 'Delete my account',
  'data.deleteWhat': 'This deletes:',
  'data.delete1': 'your account and sign-in',
  'data.delete2': 'your profile, family details, schools and essays',
  'data.delete3': 'your planner, applications and tasks',
  'data.delete4': 'your application inbox and its messages',
  'data.delete5': 'consent records and extension connections',
  'data.deleteKept': 'Stripe keeps payment records (amount, date, last four card digits) as tax and anti-fraud law requires. We keep a record that an account was deleted, with no personal details.',
  'data.deleteFinal': 'This can’t be undone. You may want to download your data first.',
  'data.deleteType': 'Type DELETE to confirm',
  'data.deleteButton': 'Delete my account',
  'data.rightsTitle': 'Your rights',
  'data.rightAccess': 'Get a copy of your data with “Download my data”.',
  'data.rightCorrect': 'Correct it by editing your {profile}.',
  'data.rightDelete': 'Delete it with “Delete my account”.',
  'data.rightWithdraw': 'Withdraw consent by unticking any scholarship-matching detail in your profile.',
  'data.rightObject': 'Object to, or restrict, how we use your data.',
  'data.rightPort': 'Take your data to another service: the download is a standard JSON file.',
  'data.rightComplain': 'Complain to your data protection authority.',
  'data.contact': 'Questions or requests? Email {email}. We answer within one month.',
  'data.profileLink': 'profile',

  /* goodbye, not found, legal */
  'bye.title': 'Your account has been deleted',
  'bye.text': 'We’ve deleted your PathsAbroad account and data. Thank you for trying PathsAbroad, and good luck with your studies.',
  'nf.title': 'We can’t find that page',
  'nf.text': 'The link may be broken, or the page may have moved.',
  'legal.contents': 'Contents',
  'legal.effective': 'Effective date: {date}',
  'legal.top': 'Back to top',

  /* AI: the AI guide and essay feedback */
  'err.ai_unavailable': 'The AI isn’t available right now. Try again later.',
  'aiCheck.title': 'Was this written by PathsAbroad’s AI?',
  'aiCheck.lead': 'Paste a text to check whether it is an answer from PathsAbroad’s AI guide or essay feedback. Every AI answer is marked when it is written, and we keep a fingerprint of it (never the text itself).',
  'aiCheck.label': 'Text to check',
  'aiCheck.hint': 'Paste the whole answer, exactly as it was shown. A changed or partial text won’t match.',
  'aiCheck.empty': 'Paste a text to check.',
  'aiCheck.submit': 'Check',
  'aiCheck.yes.title': 'Yes: PathsAbroad’s AI wrote this',
  'aiCheck.yes.text': 'This text matches an answer from PathsAbroad’s AI on {date}.',
  'aiCheck.no.title': 'No match',
  'aiCheck.no.text': 'This text doesn’t match any answer from PathsAbroad’s AI. It may have been written by a person, changed, or written by another tool.',
  'aiCheck.how': 'How it works: each AI answer carries signed details (who wrote it, when, and a fingerprint of the text). This check compares the fingerprint of what you paste with those of PathsAbroad’s AI answers. It shows nothing about the student.',

  /* reminders: WhatsApp and email */
  'nav.reminders': 'Reminders',
  'rem.title': 'Reminders',
  'rem.lead': 'We email you about deadlines, offer replies, missing documents and decisions. You can get them on WhatsApp too.',
  'rem.on': 'On',
  'rem.waTitle': 'WhatsApp',
  'rem.waOff': 'WhatsApp reminders aren’t available yet. Email reminders work now.',
  'rem.waOn': 'Reminders go to {phone} on WhatsApp.',
  'rem.waPhone': 'Your WhatsApp number',
  'rem.waPhoneHint': 'With the country code, for example +91 98765 43210.',
  'rem.waConsent': 'Send me WhatsApp messages from PathsAbroad about my applications (deadlines, offer replies, missing documents and decisions), and a code to confirm my number. I can stop at any time by replying STOP.',
  'rem.waConsentNeeded': 'Tick the box to agree to WhatsApp reminders.',
  'rem.waSend': 'Send the code',
  'rem.waSent': 'We sent a 6-digit code to {phone} on WhatsApp. It works for 10 minutes.',
  'rem.waCode': 'Code from WhatsApp',
  'rem.waConfirm': 'Confirm',
  'rem.waResend': 'Send a new code',
  'rem.waOther': 'Use another number',
  'rem.waConfirmed': 'WhatsApp reminders are on. We sent a first message to {phone}.',
  'rem.waStop': 'Stop WhatsApp reminders',
  'rem.waStopped': 'WhatsApp reminders are off. We erased your number.',
  'rem.waStoppedReply': 'You stopped WhatsApp reminders by replying STOP. We erased your number.',
  'rem.waUnreachable': 'WhatsApp couldn’t deliver to {phone}. Check the number and set it up again.',
  'rem.waChanged': 'Your WhatsApp number changed, so reminders to {phone} stopped. Add your new number to keep getting them.',
  'rem.phoneInvalid': 'Enter your WhatsApp number with its country code, for example +91 98765 43210.',
  'rem.phoneNotMobile': 'Enter a mobile number.',
  'rem.phoneNotWhatsApp': 'This number can’t get WhatsApp messages. Check it, or use email reminders.',
  'rem.emailTitle': 'Email',
  'rem.emailLabel': 'Email reminders to {email}',
  'rem.emailOnDone': 'Email reminders are on.',
  'rem.emailOffDone': 'Email reminders are off.',
  'rem.kindsTitle': 'What you get reminders about',
  'rem.kindDeadlines': 'Deadlines',
  'rem.kindDeadlinesDesc': 'Tasks with a due date and scholarship deadlines: 7, 3 and 1 days before, and on the day.',
  'rem.kindOffers': 'Offer replies',
  'rem.kindOffersDesc': 'The date to accept or decline an offer, from your admissions emails.',
  'rem.kindDocuments': 'Missing documents',
  'rem.kindDocumentsDesc': 'When a university writes that something is missing from your application.',
  'rem.kindDecisions': 'Decisions',
  'rem.kindDecisionsDesc': 'When a university sends a decision. The message never says what the decision is.',
  'rem.when': 'Reminders arrive between 09:00 and 20:00 in your time zone ({tz}).',
  'rem.test': 'Send a test reminder',
  'rem.testSent': 'Test sent. Check WhatsApp or your email.',
  'rem.saved': 'Saved.',
  'rem.recentTitle': 'Recent reminders',
  'rem.recentNone': 'No reminders yet.',
  'rem.kind.deadline': 'Deadline',
  'rem.kind.offer_reply': 'Offer reply',
  'rem.kind.missing_documents': 'Missing documents',
  'rem.kind.decision': 'Decision',
  'rem.kind.scholarship': 'Scholarship deadline',
  'rem.kind.test': 'Test',
  'rem.status.queued': 'Sending',
  'rem.status.sent': 'Sent',
  'rem.status.delivered': 'Delivered',
  'rem.status.read': 'Read',
  'rem.status.failed': 'Not delivered',
  'rem.channel.whatsapp': 'WhatsApp',
  'rem.channel.email': 'Email',
  'rem.privacy': 'WhatsApp messages go through Meta’s WhatsApp Business Platform. Your number is stored encrypted and erased when you stop. Details are in the {privacy}.',
  'rem.privacyLink': 'privacy notice',
  'rem.parentsTitle': 'Parents on WhatsApp',
  'rem.parentsLead': 'A parent you share your progress page with can add their own WhatsApp number on that page. They get reminders only about what the page shows, and stopping the page stops their reminders too.',
  'rem.parentRow': 'Parent ({label})',
  'rem.parentRowNoLabel': 'Parent',
  'rem.parentPending': 'Waiting for the code',
  'rem.parentStop': 'Stop',
  'rem.parentStoppedDone': 'Stopped. Their number is erased.',
  'rem.parentLinkStopped': 'Stopped with the progress page',

  /* parents: progress page and "parent pays" */
  'nav.family': 'Family',
  'fam.title': 'Family',
  'fam.lead': 'Share your progress with a parent, and send a link so someone else can pay for a pass. You decide what they see, and you can stop sharing at any time.',
  'fam.share.title': 'Share your progress',
  'fam.share.sees': 'What they see',
  'fam.share.see1': 'Your universities and where each application stands.',
  'fam.share.see2': 'Coming deadlines, if you turn them on.',
  'fam.share.see3': 'Decisions, if you turn them on.',
  'fam.share.see4': 'Which passes you have.',
  'fam.share.never': 'They never see your essays, emails, profile, passport details or chats, and they can’t change anything.',
  'fam.form.lang': 'Language of their page',
  'fam.form.label': 'Who is it for?',
  'fam.form.labelHint': 'Only you see this, for example Mum or Dad.',
  'fam.form.deadlines': 'Show coming deadlines',
  'fam.form.deadlinesNote': 'The titles of your open tasks that have a due date.',
  'fam.form.decisions': 'Show decisions',
  'fam.form.decisionsNote': 'Offers, refusals and waiting lists. When this is off, decided applications show as submitted.',
  'fam.form.create': 'Create a link',
  'fam.created': 'Your link is ready to send.',
  'fam.links.title': 'Your links',
  'fam.links.empty': 'No links yet.',
  'fam.link.view': 'Progress page',
  'fam.link.pay': 'Payment link: {plan}',
  'fam.link.for': 'For {label}',
  'fam.link.inLang': 'In {language}',
  'fam.link.until': 'Works until {date}',
  'fam.link.opened': 'Last opened {date}',
  'fam.link.notOpened': 'Not opened yet',
  'fam.link.status.active': 'Active',
  'fam.link.status.used': 'Paid',
  'fam.link.status.expired': 'Expired',
  'fam.link.status.revoked': 'Stopped',
  'fam.link.copy': 'Copy link',
  'fam.link.whatsapp': 'Send on WhatsApp',
  'fam.link.email': 'Send by email',
  'fam.link.stop': 'Stop sharing',
  'fam.link.cancel': 'Cancel link',
  'fam.link.edit': 'Change what they see',
  'fam.link.saved': 'Saved.',
  'fam.msg.view': 'Hello! You can follow my study-abroad applications on PathsAbroad here: {url}',
  'fam.msg.viewSubject': 'My study-abroad applications',
  'fam.msg.pay': 'Hello! Could you help me pay for my PathsAbroad {plan} pass? Here is the secure payment link: {url}',
  'fam.msg.paySubject': 'Paying for my PathsAbroad pass',
  'fam.pay.title': 'Ask a parent to pay',
  'fam.pay.lead': 'Send a payment link to whoever pays for your studies. They pay with Stripe, and the pass goes to your account. The link works once, for 14 days.',
  'fam.pay.plan': 'Plan',
  'fam.pay.create': 'Create a payment link',
  'fam.pay.covered': 'Your passes already cover every plan.',
  'fam.pay.buyer': 'The person who pays gets the receipt. All sales are final: no refunds.',
  'fam.tooMany': 'You already have 10 working links of this kind. Stop one first.',
  'fam.view.title': 'Study-abroad progress',
  'fam.view.titleName': '{name}’s study-abroad progress',
  'fam.view.lead': '{name} shares this page with you. It shows where each university application stands. Nothing can be changed here, and {name} can stop sharing at any time.',
  'fam.view.leadNoName': 'A student shares this page with you. It shows where each university application stands. Nothing can be changed here, and the student can stop sharing at any time.',
  'fam.view.unis': 'Universities',
  'fam.view.unisEmpty': 'No universities on the list yet.',
  'fam.view.deadlines': 'Coming up',
  'fam.view.deadlinesEmpty': 'Nothing due in the next few months.',
  'fam.view.due': 'Due {date}',
  'fam.view.decisionsHidden': 'Decisions aren’t shown on this page.',
  'fam.view.passes': 'PathsAbroad passes',
  'fam.view.passUntil': '{plan}: active until {date}',
  'fam.view.noPass': 'No paid pass at the moment. If one is needed, the student can send you a payment link.',
  'fam.view.updated': 'Up to date as of {date}.',
  'fam.view.about': 'PathsAbroad helps students choose universities abroad, apply, get their visa and settle in.',
  'fam.view.invalid.title': 'This link doesn’t work any more',
  'fam.view.invalid.text': 'The student may have stopped sharing, or the link expired. Ask them for a new one.',
  'fam.wa.title': 'Reminders on WhatsApp',
  'fam.wa.lead': 'Get a WhatsApp message from PathsAbroad when something on this page is due. You only hear about what {name} chose to show here.',
  'fam.wa.leadNoName': 'Get a WhatsApp message from PathsAbroad when something on this page is due. You only hear about what the student chose to show here.',
  'fam.wa.phone': 'Your WhatsApp number',
  'fam.wa.phoneHint': 'With the country code, for example +234 803 123 4567.',
  'fam.wa.consent': 'Send me WhatsApp messages from PathsAbroad about {name}’s applications, and a code to confirm my number. I can stop at any time by replying STOP or with the Stop reminders button.',
  'fam.wa.consentNoName': 'Send me WhatsApp messages from PathsAbroad about the student’s applications, and a code to confirm my number. I can stop at any time by replying STOP or with the Stop reminders button.',
  'fam.wa.consentNeeded': 'Tick the box to agree to WhatsApp reminders.',
  'fam.wa.send': 'Send the code',
  'fam.wa.sent': 'We sent a 6-digit code to {phone} on WhatsApp. It works for 10 minutes.',
  'fam.wa.code': 'Code from WhatsApp',
  'fam.wa.confirm': 'Confirm',
  'fam.wa.resend': 'Send a new code',
  'fam.wa.other': 'Use another number',
  'fam.wa.done': 'Done. Reminders will come to {phone} on WhatsApp. Reply STOP at any time to stop them.',
  'fam.wa.phoneInvalid': 'Enter your WhatsApp number with its country code, for example +234 803 123 4567.',
  'fam.wa.phoneNotMobile': 'Enter a mobile number.',
  'fam.wa.phoneNotWhatsApp': 'This number can’t get WhatsApp messages. Please check it.',
  'fam.wa.badCode': 'That code isn’t right, or it has expired. Check the WhatsApp message, or ask for a new code.',
  'fam.wa.privacy': 'Your number is stored encrypted. It is erased when you stop, or when the student stops sharing this page.',
  'fam.status.applying': 'Preparing the application',
  'fam.status.submitted': 'Submitted',
  'fam.status.offer': 'Offer',
  'fam.status.offer_conditional': 'Conditional offer',
  'fam.status.waitlisted': 'On the waiting list',
  'fam.status.deferred': 'Decision deferred',
  'fam.status.not_admitted': 'Not admitted',
  'fam.status.accepted': 'Offer accepted',
  'fam.status.declined': 'Offer declined',
  'fam.status.withdrawn': 'Withdrawn',
  'pay.title': 'Pay for a PathsAbroad pass',
  'pay.titleName': 'Pay for {name}’s {plan} pass',
  'pay.lead': '{name} sent you this link to pay for their PathsAbroad {plan} pass. The pass is for {name}’s account; you don’t need an account yourself.',
  'pay.leadNoName': 'A student sent you this link to pay for their PathsAbroad {plan} pass. The pass is for their account; you don’t need an account yourself.',
  'pay.price': 'Price',
  'pay.oneTime': 'One-time payment. No automatic renewal.',
  'pay.valid': 'Lasts {months} from the day you pay.',
  'pay.includes': 'What it includes',
  'pay.refund': 'All sales are final: no refunds. If the student gets no offer, the pass rolls over to next season.',
  'pay.formTitle': 'Pay',
  'pay.email': 'Your email',
  'pay.emailHint': 'For your receipt.',
  'pay.country': 'Where do you live?',
  'pay.startNowTitle': 'Before you pay',
  'pay.startNow': 'Start the pass as soon as I pay. I understand that all sales are final: once it starts, it can’t be cancelled or refunded.',
  'pay.startNowNote': 'If the student doesn’t get an offer, the pass rolls over to the next season, free.',
  'pay.submit': 'Pay {price} with Stripe',
  'pay.secure': 'Stripe handles the payment. PathsAbroad never sees your card number.',
  'pay.canceled': 'The payment was canceled. You haven’t been charged.',
  'pay.paid.title': 'This pass is paid',
  'pay.paid.text': 'Thank you. The pass is active on the student’s account, and the person who paid has an email with the receipt.',
  'pay.covered.title': 'Nothing to pay',
  'pay.covered.text': 'The student’s passes already include this plan.',
  'pay.invalid.title': 'This payment link doesn’t work any more',
  'pay.invalid.text': 'It may have expired or been canceled. Ask the student for a new one.',
  'pay.done.title': 'Thank you',
  'pay.done.waiting': 'Confirming your payment…',
  'pay.done.ready': 'Paid. The {plan} pass is active on the student’s account. We emailed you a confirmation.',
  'pay.done.slow': 'Your payment went through, but confirming it is taking longer than usual. We’ll email you when it’s done.',
  'pay.wd.title': 'Your purchase',
  'pay.wd.lead': 'You paid for the {plan} pass for {name} on {date}.',
  'pay.wd.leadNoName': 'You paid for a PathsAbroad {plan} pass on {date}.',
  'pay.wd.until': 'You can withdraw for a full refund until {date}.',
  'pay.wd.confirm1': 'You get a full refund, {price}, to the card you paid with.',
  'pay.wd.confirm2': 'The pass ends straight away on the student’s account.',
  'pay.wd.confirm3': 'We’ll email you a dated receipt.',
  'pay.wd.keep': 'Keep the pass',
  'pay.wd.done': 'Refunded on {date}. The refund is on its way to the card you paid with.',
  'pay.wd.over': 'All sales are final: this purchase can’t be withdrawn or refunded.',
  'pay.wd.invalid': 'This withdrawal link isn’t valid.',
  'plans.askParent': 'Ask a parent to pay',
  'plans.askParentMinor': 'Under 18? A parent or guardian can pay for your pass. Send them a secure payment link.',
  'pass.byParent': 'Paid through your payment link',

  /* the landing page ("/") */
  'land.nav.label': 'On this page',
  'land.nav.money': 'Scholarships',
  'land.nav.how': 'How it works',
  'land.nav.features': 'Features',
  'land.nav.trust': 'Privacy',
  'land.nav.pricing': 'It’s free',
  'land.nav.faq': 'Questions',
  'land.nav.demo': 'Demo',
  'land.getStarted': 'Get started',
  'land.globe.title': 'Where do you want to go?',
  'land.globe.lead': 'Tap anywhere on the globe. We’ll zoom in on the closest university and show you what it’s like.',
  'land.globe.search': 'Search a city, country or university',
  'land.globe.none': 'Nothing found. Try a city, a country or a university.',
  'land.globe.aria': 'A globe with {unis} universities, turning slowly. Drag to turn it, scroll up or pinch to zoom, and tap anywhere to see the closest university. With a keyboard: the arrow keys turn it, + and − zoom, and Enter shows the university closest to the middle.',
  'land.globe.closest': 'Closest university',
  'land.globe.yourPick': 'Your pick',
  'land.globe.away': '{d} from where you tapped',
  'land.globe.here': 'Right where you tapped',
  'land.globe.km': '{n} km',
  'land.globe.close': 'Close',
  'land.globe.rank': 'World rank',
  'land.globe.notRanked': 'Not ranked',
  'land.globe.inCountry': 'In {country}',
  'land.globe.rankOf': '#{r} of {n}',
  'land.globe.cost': 'A year',
  'land.globe.costOwn': 'Its tuition ({year}) and living',
  'land.globe.costOwn0': 'Its tuition and living',
  'land.globe.costEst': 'Estimate: tuition and living',
  'land.globe.admit': 'Acceptance rate',
  'land.globe.admitYear': 'In {year}',
  'land.globe.select': 'How selective',
  'land.globe.sel.high': 'Very selective',
  'land.globe.sel.mid': 'Selective',
  'land.globe.sel.some': 'Fairly selective',
  'land.globe.sel.low': 'Less selective',
  'land.globe.sel.open': 'Open admission',
  'land.globe.selRank': 'From its world rank',
  'land.globe.public': 'Public',
  'land.globe.private': 'Private',
  'land.globe.cc': 'Community college',
  'land.globe.taught': 'Courses in {country}: {langs}',
  'land.globe.students': '{n} students',
  'land.globe.founded': 'Founded {year}',
  'land.globe.begin': 'Let’s begin',
  'land.globe.demo': 'Try the demo',
  'land.globe.again': 'Pick somewhere else',
  'land.hero.note': 'Free for every student. No ads, no tracking.',
  'land.hero.signin': 'Already have an account? {link}',
  'land.facts.label': 'PathsAbroad at a glance',
  'land.facts.unis': '{unis} universities in {countries} countries',
  'land.facts.langs': 'In English, Arabic, Hindi and Indonesian',
  'land.facts.portals': 'Fills in the Common App, UCAS, OUAC and uni-assist',
  'land.facts.ads': 'No ads, and your data is never sold',
  'land.how.title': 'From a tap on the globe to your first week abroad.',
  'land.how.lead': 'Seven steps, one app. At each one, here’s what you do and what PathsAbroad does for you.',
  'land.how.step': 'Step {n} of {total}',
  'land.how.you': 'You',
  'land.how.s1.title': 'Pick the places you’d love to study',
  'land.how.s1.time': 'About a minute',
  'land.how.s1.text': 'It starts on a globe. Tap the glowing dots, or search for a city, a country or a university: {unis} universities in {countries} countries, each where it really is.',
  'land.how.s1.you': 'Tap every place that catches your eye.',
  'land.how.s1.pa': 'Finds the universities nearest each place, nearest first, with the distance.',
  'land.how.s2.title': 'Answer five quick questions',
  'land.how.s2.time': 'About two minutes',
  'land.how.s2.text': 'A short chat about you and home, the work you want to do, your grades, your English and your budget. Say “civil engineer” and the guide works out the degree that gets you there.',
  'land.how.s2.you': 'Answer in your own words, or tap a suggestion.',
  'land.how.s2.pa': 'Turns your answers into a profile it can match against every university.',
  'land.how.s3.title': 'Meet your matches',
  'land.how.s3.time': 'Right away',
  'land.how.s3.text': 'Your matches light up on the globe, ranked for your grades, budget and goals. Each one shows why it fits, what a year costs and your chance of getting in, with the scholarships that suit you.',
  'land.how.s3.you': 'Keep the ones you like, or add any university you want. A free account saves your list.',
  'land.how.s3.pa': 'Is honest about your chances: likely, good fit or ambitious.',
  'land.how.s4.title': 'Follow your plan, one step at a time',
  'land.how.s4.time': 'As you go',
  'land.how.s4.text': 'Home always shows your next step and what’s coming up: documents, recommendation letters, essays and fees for every university, in date order. The AI guide walks you through each one. Your essays start from your own notes, and you get feedback, never a rewrite.',
  'land.how.s4.you': 'Do the next step whenever you’re ready.',
  'land.how.s4.pa': 'Keeps every date in order and, if you like, reminds you on WhatsApp or by email.',
  'land.how.s5.title': 'Fill in forms in seconds, then submit',
  'land.how.s5.time': 'Seconds a page',
  'land.how.s5.text': 'On the Common App, UCAS, OUAC and uni-assist, press “Fill this page” and the PathsAbroad Chrome extension puts in the answers you’ve already given. You check every field, write your own essays and press submit.',
  'land.how.s5.you': 'Check each field, then submit and pay on the university’s own site.',
  'land.how.s5.pa': 'Fills in what you’ve told it. Never your essays or passwords, and it never clicks submit or pay.',
  'land.how.s6.title': 'Hear back in one place',
  'land.how.s6.time': 'Whenever news arrives',
  'land.how.s6.text': 'Universities write to your own PathsAbroad address. Decisions, interview invitations and requests for documents are sorted as they arrive, and the next step goes on your list. Your family can follow along on a read-only page.',
  'land.how.s6.you': 'Read the news and reply to your offers.',
  'land.how.s6.pa': 'Sorts every email and pulls out the dates and next steps.',
  'land.how.s7.title': 'Get ready to go',
  'land.how.s7.time': 'Once you have an offer',
  'land.how.s7.text': 'Your visa checklist, with links to official sources, plus funding from home and abroad, housing, food, student jobs and your first weeks. General information, not immigration or legal advice.',
  'land.how.s7.you': 'Accept your offer and work through your list.',
  'land.how.s7.pa': 'Shows the steps for where you’re going, and warns you when a visa rule affects your nationality.',
  'land.money.eyebrow': 'Scholarships',
  'land.money.title': 'We find the money. Every scholarship, checked for you.',
  'land.money.lead': 'Scholarships for international students are spread across hundreds of government and foundation websites. PathsAbroad checks {n} of them in {countries} countries against your nationality, your level and where you want to go, and shows what each one is worth.',
  'land.money.s1': 'scholarships and grants, checked for every student',
  'land.money.s2': 'a year: the most one of them is worth',
  'land.money.s3': 'countries, with their governments’ scholarships and the big international funders',
  'land.money.ex_eyebrow': 'Example',
  'land.money.ex_who': 'Amina, from Jordan, wants a master’s in Canada, the UK or Germany',
  'land.money.ex_v': '{n} scholarships she can apply for, worth up to {amt} a year',
  'land.money.peryear': '{amt} a year',
  'land.money.eu': 'Europe',
  'land.money.intl': 'International',
  'land.money.cta': 'See the scholarships you can get',
  'land.money.fine': 'Values are per year, from each program’s own pages. Where a program pays “full tuition”, we price it at a typical fee and call it an estimate. Scholarships usually can’t be combined. Checked October 2026.',
  'land.how.d.where': 'Where could you see yourself?',
  'land.how.d.continue': 'Continue ({n})',
  'land.how.d.guide': 'AI guide',
  'land.how.d.career': 'What do you want to do for a living? I’ll work out the right degree from that.',
  'land.how.d.civil': 'Civil engineer',
  'land.how.d.level': 'To become a civil engineer, the usual next step after a bachelor’s degree is a master’s. Shall I go with that?',
  'land.how.d.yes': 'Yes',
  'land.how.d.finding': 'Finding your matches…',
  'land.how.d.scholar': '3 scholarships match you',
  'land.how.d.save': 'Save my list',
  'land.how.d.next': 'Next: Get 3 recommendations. Tap and I will walk you through it.',
  'land.how.d.ask': 'Ask',
  'land.how.d.task': 'Get 3 recommendations',
  'land.how.d.due': 'Due in 2 days',
  'land.how.d.doIt': 'Do it now',
  'land.how.d.coming': 'Coming up',
  'land.how.d.deadline': 'Application deadline: {school}',
  'land.how.d.inDays': 'in {n} days',
  'land.how.d.trip': 'Your trip',
  'land.how.d.starts': 'Classes start in September',
  'land.how.d.visa': 'Your visa checklist',
  'land.features.title': 'Everything for studying abroad, in one place.',
  'land.features.lead': 'Here’s how it looks for an example student, Amina from Jordan.',
  'land.match.eyebrow': 'Find your fit',
  'land.match.title': 'Universities that fit you, with honest chances.',
  'land.match.text': 'Tell PathsAbroad your grades, budget and goals. It suggests universities that fit, with the cost per year and your chance at each: likely, good fit or ambitious.',
  'land.match.p1': 'See why each university fits you, and what it costs.',
  'land.match.p2': 'Your top scholarships, matched to your profile.',
  'land.match.p3': 'Add any university, including ones we didn’t suggest.',
  'land.apply.eyebrow': 'Apply',
  'land.apply.title': 'Fill in application forms in seconds. Submit them yourself.',
  'land.apply.text': 'The PathsAbroad Chrome extension puts your saved answers into the Common App, UCAS, OUAC and uni-assist when you press “Fill this page”. You check every field.',
  'land.apply.p3': 'It only works when you press the button, and it stays off visa and government websites.',
  'land.inbox.eyebrow': 'Inbox',
  'land.inbox.title': 'Every admissions email, sorted for you.',
  'land.inbox.text': 'Use your own PathsAbroad email address on application portals. Decisions, interview invitations and requests for documents are sorted, and the next step goes on your to-do list.',
  'land.inbox.p1': 'Dates and next steps pulled out of every email.',
  'land.inbox.p2': 'Reminders before each deadline, if you want them.',
  'land.inbox.p3': 'Full emails are kept encrypted for 30 days, then deleted.',
  'land.ai.title': 'An AI guide that explains, and never writes for you.',
  'land.ai.text': 'Ask about courses, costs or visas and get plain answers, always labeled as AI. Each essay starts with notes from your own answers; you write it, then get feedback, never a rewritten essay. The AI is free for every student.',
  'land.reminders.title': 'Reminders on WhatsApp or email.',
  'land.reminders.text': 'Get a message 7, 3 and 1 day before a deadline, and on the day. Reply STOP to end them.',
  'land.visa.title': 'Visa steps and your first weeks.',
  'land.visa.text': 'A checklist for each destination with links to official sources, then housing, food and student jobs. General information, not immigration or legal advice.',
  'land.family.title': 'Bring your family along.',
  'land.family.text': 'Share a read-only progress page with a parent or anyone you choose. Stop sharing at any time.',
  'land.lang.title': 'In your language.',
  'land.lang.text': 'Use PathsAbroad in English, Arabic, Hindi or Indonesian, and switch at any time.',
  'land.trust.title': 'Built to protect students.',
  'land.trust.lead': 'Passport numbers, grades and family details are some of the most personal things you share. Here’s how PathsAbroad keeps them safe.',
  'land.trust.enc.title': 'Encrypted before it’s saved',
  'land.trust.enc.text': 'Your passport number, date of birth, family income, everything you save in the planner and your admissions emails are encrypted with AES-256-GCM. The database only ever stores the scrambled version.',
  'land.trust.rls.title': 'Only you can see your records',
  'land.trust.rls.text': 'Every row in the database is locked to its owner with row-level security, so no student can read another student’s data.',
  'land.trust.redact.title': 'Private details stay out of AI',
  'land.trust.redact.text': 'Passport numbers, dates of birth, phone numbers, emails and addresses are removed before anything goes to the AI. Race, religion and family income are never sent.',
  'land.trust.ai.title': 'AI text is always labeled',
  'land.trust.ai.text': 'Everything the AI writes is marked as AI, and anyone can check whether a text came from PathsAbroad.',
  'land.trust.aiCheck': 'Check a text',
  'land.trust.mfa.text': 'Add a code from an authenticator app, so a stolen password isn’t enough.',
  'land.trust.help.title': 'Help when it matters',
  'land.trust.help.text': 'If a message suggests someone may be in danger, the AI guide replies with crisis lines for their country.',
  'land.trust.data.title': 'Your data, your choice',
  'land.trust.data.text': 'Download everything, or delete your account, at any time. Nothing is sold or used for advertising.',
  'land.price.title': 'Free for every student.',
  'land.price.lead': 'No passes, no subscription, no card. Everything in PathsAbroad is free for students going to study in another country.',
  'land.price.from': 'Where are you from?',
  'land.price.to': 'Where do you want to study?',
  'land.price.chooseFrom': 'Choose your country',
  'land.price.chooseTo': 'Choose a country',
  'land.price.notSure': 'Not sure yet',
  'land.price.pick': 'Answer both questions to see your price.',
  'land.price.yours': 'Your price to study in {country}',
  'land.price.yoursAny': 'Your price',
  'land.price.freeNote': 'Everything, with no time limit',
  'land.price.how': 'How we’re paid: some universities and student services (loans, housing, blocked accounts) pay PathsAbroad a fee when a student enrols or signs up through us. It never costs you anything extra, and it never changes your matches: they’re ranked only by how well each university fits you.',
  'land.price.abroad': 'PathsAbroad is for studying outside your own country, so we don’t show universities in the country you’re from.',
  'land.price.for': 'One payment, lasts {months}',
  'land.price.usd': 'Prices are in US dollars, and you always see your price before you pay.',
  'land.price.parents': 'A parent can pay for you with a secure link.',
  'land.cta.free': 'Start free',
  'land.cta.planner': 'Try the planner',
  'land.faq.title': 'Questions, answered.',
  'land.faq.q1': 'Is PathsAbroad free?',
  'land.faq.a1': 'Yes, completely: the school search, your chances, the AI guide, Autopilot, essay help, every scholarship application, the Chrome extension, the application inbox, and visa and arrival help. Universities and student services pay us, never students.',
  'land.faq.q2': 'Does PathsAbroad apply for me?',
  'land.faq.a2': 'No. You choose your universities, write your own essays, and submit and pay for every application yourself. PathsAbroad fills in your saved details, starts each essay with notes from your answers and keeps you organized.',
  'land.faq.q3': 'Is this immigration or legal advice?',
  'land.faq.a3': 'No. Visa information links to official sources and is general information, not immigration or legal advice. Always check the official website for your situation.',
  'land.faq.q4': 'Which universities can I find?',
  'land.faq.a4': '{unis} universities in {countries} countries, including the US, the UK, Canada, Australia and Germany. PathsAbroad is for studying abroad, so universities in your own country aren’t shown. You can also add any university yourself.',
  'land.faq.q5': 'What if I’m under 18?',
  'land.faq.a5': 'A parent or guardian approves your account before you can save your details, and a few sensitive profile questions stay switched off.',
  'land.faq.q6': 'How does PathsAbroad make money?',
  'land.faq.a6': 'Some universities and student services pay us a fee when a student enrols or signs up through PathsAbroad. You never pay us, and the fee never changes which universities we match you with.',
  'land.faq.q7': 'Can my parents see my progress?',
  'land.faq.a7': 'Only if you choose. You can share a read-only page with a parent or guardian, and stop sharing at any time.',
  'land.faq.q8': 'What happens to my data?',
  'land.faq.a8': 'Sensitive answers are encrypted, and nothing is sold or used for advertising. You can download or delete everything from your account.',
  'land.final.title': 'Start your path today.',
  'land.final.text': 'Create a free account, or try the planner first.',
  'land.demo.example': 'Example',
  'land.demo.matches': 'Your matches',
  'land.demo.inbox': 'Application inbox',
  'land.demo.decision': 'Decision',
  'land.demo.nextReply': 'Next step added to your list',
  'land.demo.whatsapp': 'WhatsApp',
  'land.demo.reminder': '3 days left to reply to your offer from {school}.',
  'land.demo.all': 'All',
  'land.demo.likely': 'Likely',
  'land.demo.fit': 'Good fit',
  'land.demo.ambitious': 'Ambitious',
  'land.demo.estimate': 'Chances are estimates, not promises.',
  'land.demo.firstName': 'First name',
  'land.demo.lastName': 'Last name',
  'land.demo.citizenship': 'Citizenship',
  'land.demo.essay': 'Personal essay',
  'land.demo.youWrite': 'You write this',
  'land.demo.submit': 'Submit',
  'land.demo.youSubmit': 'You press submit',
  'land.demo.fill': 'Fill this page',
  'land.demo.filled': '3 fields filled',
  'land.demo.offer': 'You’ve been offered a place.',
  'land.demo.interview': 'Interview',
  'land.demo.interviewText': 'Choose a time for your interview.',
  'land.demo.missing': 'Missing document',
  'land.demo.missingText': 'Upload your English test results.',
  'land.demo.todo': 'Added to your to-do list:',
  'land.demo.aiQ': 'What does a conditional offer mean?',
  'land.demo.aiA': 'The university will accept you once you meet the conditions in your letter, usually your final grades or an English test score.',
  'land.demo.visa1': 'Offer letter',
  'land.demo.visa2': 'Proof of funds',
  'land.demo.visa3': 'Health insurance',
  'land.demo.visa4': 'Book a visa appointment',
  'land.demo.parentView': 'What your parent sees',
  'land.demo.youSee': 'You see',
  'land.demo.stored': 'The database stores',
} as const;

export type MessageKey = keyof typeof en;
export type Dict = { readonly [K in MessageKey]: string };
